import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { endPoint } from "constants/server/api";
import { createFetchLogicPrototype } from "../../utils/fetchFactory";
import { createSlicePrototype } from "../../utils/sliceFactory";
import { http } from "utils/http";
var genNewReceiptDocNumberSlice = createSlicePrototype({
    name: "genNewReceiptDocNumber"
});
export var genNewReceiptDocNumber = createFetchLogicPrototype({
    actions: genNewReceiptDocNumberSlice.actions,
    configFn: function(_, param) {
        var accessToken = param.accessToken;
        return {
            method: "get",
            url: "".concat(endPoint.NEW_RECEIPT, "/gen-doc-number"),
            headers: {
                Authorization: "Bearer ".concat(accessToken)
            }
        };
    },
    onError: function(error, param) {
        var modalObj = param.modalObj, setModalObj = param.setModalObj;
        var getStatus = function(err) {
            return http.isAxiosError(err) && err.response ? err.response.status : 500;
        };
        var getMessage = function(err) {
            return http.isAxiosError(err) && err.response ? err.response.data.message : "เกิดข้อผิดพลาด\nหรือเครือข่ายขัดข้อง";
        };
        setModalObj === null || setModalObj === void 0 ? void 0 : setModalObj(_object_spread_props(_object_spread({}, modalObj), {
            visible: true,
            subTitle: "รหัส ".concat(getStatus(error)),
            navigateDirection: undefined,
            title: getMessage(error)
        }));
    }
});
export var clearGenNewReceiptDocNumber = function() {
    return function(dispatch) {
        dispatch(genNewReceiptDocNumberSlice.actions.resetState());
    };
};
var _genNewReceiptDocNumberSlice_actions = genNewReceiptDocNumberSlice.actions;
export var fetchData = _genNewReceiptDocNumberSlice_actions.fetchData, fetchDataSuccess = _genNewReceiptDocNumberSlice_actions.fetchDataSuccess, fetchDataFailure = _genNewReceiptDocNumberSlice_actions.fetchDataFailure, resetState = _genNewReceiptDocNumberSlice_actions.resetState;
export default genNewReceiptDocNumberSlice.reducer;
